import Login from "@components/icons/Login"
import { useConnectWithWalletKit } from "react-walletkit"
import { useAccount } from "wagmi"
import { Button, ButtonProps } from "../ui/base/button"
import { useSliceContext } from "../SliceProvider"

const connectText = "Go gasless" // "Login with Slice" // "Go Gasless" || "Use Slice Wallet"

const ConnectButton = (buttonProps: ButtonProps) => {
  const { isConnected } = useSliceContext()
  const { connector } = useAccount()
  const { connect } = useConnectWithWalletKit()
  const isSmartWallet = connector?.id === "walletkit"

  return (
    !isSmartWallet && (
      <Button onClick={connect} {...buttonProps}>
        <div className="sl-flex sl-items-center sl-gap-1">
          <p>{isConnected ? connectText : "Login"}</p>
          <Login className="sl-w-[18px] sl-h-[18px] sl-mt-[1px]" />
        </div>
      </Button>
    )
  )
}

export default ConnectButton
